import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Col, Collapse, Row, Space, Typography } from 'antd';
import CollapsePanel from 'antd/es/collapse/CollapsePanel';
import Link from 'antd/es/typography/Link';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { TicketDetailContext } from 'src/contexts/ticketDetail.context';
import './form.scss';
import { formatDate } from 'src/utils/utils';

const { Text } = Typography;

const EmailForm = (): JSX.Element => {
  const { ticket } = useContext(TicketDetailContext);
  const { t } = useTranslation();

  return (
    <Collapse bordered={false} defaultActiveKey={['1']} expandIconPosition='end' className='email-form-list'>
      {ticket?.data.emailForms.map((emailForm) => (
        <CollapsePanel
          key={emailForm.id}
          className='email-form-item'
          header={
            <div className='email-form-item-header'>
              <Row>
                <Col span={8}>Cấp cho:</Col>
                <Col span={16}>{emailForm.forPerson?.fullName}</Col>
              </Row>
              <Row>
                <Col span={8}>Ngày hiệu lực: </Col>
                <Col span={16}>{formatDate(emailForm.date)}</Col>
              </Row>
            </div>
          }
        >
          <div className='email-form-item-body'>
            <Row>
              <Col span={8}>Quyền gửi: </Col>
              <Col span={16}>
                <Space size={[40, 0]}>
                  <Space size={4}>
                    {emailForm.sendInternal ? (
                      <CheckOutlined style={{ color: '#52c41a' }} />
                    ) : (
                      <CloseOutlined style={{ color: '#ff4d4f' }} />
                    )}
                    <Text>{t(`columnTitle.emailForm.internal`)}</Text>
                  </Space>
                  <Space size={4}>
                    {emailForm.sendOutLimit ? (
                      <CheckOutlined style={{ color: '#52c41a' }} />
                    ) : (
                      <CloseOutlined style={{ color: '#ff4d4f' }} />
                    )}
                    <Text>{t(`columnTitle.emailForm.limit`)}</Text>
                  </Space>
                  <Space size={4}>
                    {emailForm.sendOutUnLimit ? (
                      <CheckOutlined style={{ color: '#52c41a' }} />
                    ) : (
                      <CloseOutlined style={{ color: '#ff4d4f' }} />
                    )}
                    <Text> {t(`columnTitle.emailForm.unLimit`)}</Text>
                  </Space>
                </Space>
              </Col>
            </Row>
            <Row>
              <Col span={8}>Quyền nhận: </Col>
              <Col span={16}>
                <Space size={[40, 0]}>
                  <Space size={4}>
                    {emailForm.receiptInternal ? (
                      <CheckOutlined style={{ color: '#52c41a' }} />
                    ) : (
                      <CloseOutlined style={{ color: '#ff4d4f' }} />
                    )}
                    <Text>{t(`columnTitle.emailForm.internal`)}</Text>
                  </Space>
                  <Space size={4}>
                    {emailForm.receiptLimit ? (
                      <CheckOutlined style={{ color: '#52c41a' }} />
                    ) : (
                      <CloseOutlined style={{ color: '#ff4d4f' }} />
                    )}
                    <Text>{t(`columnTitle.emailForm.limit`)}</Text>
                  </Space>
                  <Space size={4}>
                    {emailForm.receiptUnLimit ? (
                      <CheckOutlined style={{ color: '#52c41a' }} />
                    ) : (
                      <CloseOutlined style={{ color: '#ff4d4f' }} />
                    )}
                    <Text>{t(`columnTitle.emailForm.unLimit`)}</Text>
                  </Space>
                </Space>
              </Col>
            </Row>
            {(emailForm.sendOutLimit || emailForm.receiptLimit) && (
              <Row>
                <Col span={8}>Email giới hạn: </Col>
                <Col span={16}>
                  {emailForm.listOfEmailOut.split(',').map((email, index, emails) => (
                    <Text key={index}>
                      {index > 0 && ','} <Link href={`mailto:${email}`}>{email}</Link>
                    </Text>
                  ))}
                </Col>
              </Row>
            )}
          </div>
        </CollapsePanel>
      ))}
    </Collapse>
  );
};
export default EmailForm;
